import $ from "jquery";

const Sticky = require('sticky-js');

(function () {

  $(document).ready(function() {

    if (window.location.pathname.includes('fba-fee-calculator')) {
      const sticky = new Sticky('.sticky');
      sticky.update();
    }

  });

}());
